import styled from 'styled-components';

import { STEP_SLUG } from '../../constants';
import { useByocNavigationContext } from '../../context/byoc-navigation-context';
import PriceBar from '../price-bar';

const StyledFooter = styled.div`
  background-color: ${({ theme }) => theme.colors.white};
  border-top: 1px solid ${({ theme }) => theme.colors.grey30};
  box-shadow: 0px -7px 20px 0px rgba(0, 0, 0, 0.15);
  margin-top: -0.5rem;
  bottom: 0;
  position: sticky;
  z-index: ${({ theme }) => theme.zIndices.footer};

  @media (min-width: ${({ theme }) => theme.media.md}) {
    border: none;
  }

  /* Remove sticky positioning to avoid overlapping elements when viewport is too narrow on desktop devices */
  /* @media(min-resolution: 3dppx) does not work on Safari */
  @media (hover: hover) and (pointer: fine) and (max-width: ${({ theme }) => theme.media.md}) {
    position: initial;
  }
`;

const Footer = () => {
  const { activeSlug } = useByocNavigationContext();

  if (activeSlug !== STEP_SLUG.CHOOSE_COVER) {
    return null;
  }

  return (
    <StyledFooter>
      <PriceBar />
    </StyledFooter>
  );
};

export default Footer;
